module.exports = __webpack_public_path__ + "img/02_1_5_2.f197c16b.png";